import React, { useRef, useState } from "react";
import { Loader } from "lucide-react";
import { getPractice, notify } from "../../helpers";
import { Config } from "../../Config";
import { Drawer } from 'vaul';
import { uploadFidelisPatient } from "../../services/fidelisPatient";
import Spacing from "../Spacing";

export default function FidelisPatientImportModal(props) {
  const { 
    account_id,
    location_id,
    reloadData = () =>{},
    reloadDataFilter = {},
    patientDataImport= false,
    setPatientDataImport = () => {},
    previousScrollPosition = 0,
    setImportLoader = () => {}
  } = props;

  const [enableLoader, setEnableLoader] = useState(false);
  const [file, setFile] = useState(null);
  const [fileError, setFileError] = useState(false);
  const [uploadDisabled, setUploadDisabled] = useState(true);
  const dropdownRef = useRef(null);

  const handleImportFidelisPatient = async (e) => {
    e.preventDefault();
    setEnableLoader(true);
    setImportLoader(true)

    try {
      const postData = {
        account_id: account_id,
        location_id: location_id,
        file: file
      };
      const response = await uploadFidelisPatient(postData);
    
      if (response) {
        if (response?.detail) {
          notify('error', response?.detail, 2);
        } else { 
          if(response?.data?.status === 'success'){
            notify("success", response?.data?.message, 2);
            reloadData(reloadDataFilter);
            handleDrawerClose();
          } else {
            notify("error", response?.data?.message, 2);
          }
        }
      }
    } catch (error) {
      if (error?.response && error?.response?.data && error?.response?.data?.detail) {
        notify("error", error?.response?.data?.detail, 2);
      }
    } finally {
      setEnableLoader(false);
      setImportLoader(false);
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    
    if (selectedFile && selectedFile.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
      setFileError(true);
      setUploadDisabled(true);
      setFile(null);
    } else {
      setFileError(false);
      setUploadDisabled(false);
      setFile(selectedFile);
    }
  };

  const handleDrawerClose = () => {
    setPatientDataImport(false);
    window.scrollTo(0, previousScrollPosition);
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={patientDataImport} onOpenChange={handleDrawerClose}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn">
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4 large_medium">
            <Drawer.Title className="sr-only">Import Fidelis Patient</Drawer.Title>
            <Drawer.Description className="sr-only">Import new fidelis patient</Drawer.Description>
            <div className="docpro_modal_wrap docpro_modal_lg no_padding">
              <div className="docpro_modal small import">

                <form onSubmit={handleImportFidelisPatient} className="modal_height_100">
                  <div>
                    <h2 className="docpro_fs_24 docpro_mb_0 docpro_small_modal_padding_1">Import Fidelis Patient</h2>
                    
                    <div className="docpro_badge_green" style={{ padding: '12px 24px' }}>
                      <p className="mb-0"><span style={{ fontWeight: 600 }}>Account Name:</span> {getPractice("account_name")}</p>
                      <p className="mb-0"><span style={{ fontWeight: 600 }}>Location Name:</span> {getPractice("location_name")}</p>
                    </div>
                    <Spacing lg="20" sm="20" />

                    <div className="docpro_small_modal_padding_2">
                      <div>
                        <label className="docpro_primary_color rejection_sheet">
                          <span>
                            <span className="docpro_fw_500">Fidelis Patient</span> <small className="docpro_red_color">(.xlsx)</small>
                          </span>
                          <a 
                            href={`${Config.appUrl}/pdf/Fidelis-Care-Patients.xlsx`}
                            target="_blank"
                            rel="noopener noreferrer"
                            download="Fidelis Patients" 
                            title="click here to download Sample" 
                            className="docpro_red_color"
                          >Download Sample</a>
                        </label>
                        <div className='input_file_conatiner'>
                          <label htmlFor="file-upload" className='file_button'>
                            Choose Files
                          </label>
                          <input
                            type="file"
                            id="file-upload"
                            accept=".xlsx"
                            className='file_hidden_input'
                            onChange={handleFileChange}
                          />
                          <span className='file_label'>{file ? `${file?.name}` : 'No file chosen'}</span>
                        </div>
                        {fileError && (
                          <p className="docpro_error_message">
                            Please upload a valid Excel file.
                          </p>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="docpro_modal_btns small_buttons docpro_mt_auto docpro_small_modal_padding_3">
                    <button
                      type="button"
                      className="docpro_bordered_btn docpro_fw_600 size_lg"
                      onClick={() => handleDrawerClose()}
                    >
                      Cancel
                    </button>
                    <button
                      type='submit'
                      className="docpro_bordered_btn docpro_fw_600 docpro_filed_btn size_lg"
                      disabled={uploadDisabled ? true : false}
                    >
                      Upload
                    </button>
                  </div>
                </form>

                {enableLoader &&
                  <div className="flex items-center loading" style={{ width: '100%', height: '100%', position: 'absolute', top: 0, background: '#ffffff9c', borderRadius: '10px', justifyContent: 'center' }}>
                    <span className="docpro_loading" style={{ position: 'inherit' }}>
                      <Loader width={46} height={46} style={{ color: 'var(--accent)' }} />
                    </span>
                  </div>
                }
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
